import { useHeatReportContext } from "@/pages/heat-report/context/HeatReportContext";
import { Grid2 as Grid } from "@mui/material";
import { HeaderData } from "./components/HeaderData";
import { BilletTempChart } from "./components/charts/billet-temp/BilletTempChart";
import { MoldLevelChart } from "./components/charts/mold-level/MoldLevelChart";
import { StrandSpeedChart } from "./components/charts/strand-speed/StrandSpeedsChart";
import { LostStrandsReadOnly } from "./components/tables/lost-strands/LostStrandsReadOnly";
import { ProbesTable } from "./components/tables/probes-table/ProbesTable";
import { ProductionTable } from "./components/tables/production-table/ProductionTable";
import { ScrapTable } from "./components/tables/scrap-table/ScrapTable";
import { StrandTable } from "./components/tables/strand-table/StrandTable";

export const CasterProcessData = () => {
	const {
		state: { casProcessData },
	} = useHeatReportContext();
	return (
		<Grid container spacing={1}>
			<Grid size={{ xs: 12 }}>
				<HeaderData key={casProcessData.ProcessId} />
			</Grid>

			<Grid size={{ xs: 3 }}>
				<ProbesTable key={casProcessData.ProcessId} />
			</Grid>

			<Grid size={{ xs: 3 }} container spacing={1}>
				<Grid size={{ xs: 12 }}>
					<ProductionTable key={casProcessData.ProcessId} />
				</Grid>
				<Grid size={{ xs: 12 }}>
					<ScrapTable key={casProcessData.ProcessId} />
				</Grid>
			</Grid>

			<Grid size={{ xs: 6 }}>
				<StrandTable key={casProcessData.ProcessId} />
			</Grid>

			<Grid size={{ xs: 3 }}>
				<StrandSpeedChart key={casProcessData.ProcessId} />
			</Grid>
			<Grid size={{ xs: 3 }}>
				<MoldLevelChart key={casProcessData.ProcessId} />
			</Grid>
			<Grid size={{ xs: 3 }}>
				<BilletTempChart key={casProcessData.ProcessId} />
			</Grid>
			<Grid size={{ xs: 3 }}>
				<LostStrandsReadOnly key={casProcessData.ProcessId} />
			</Grid>
		</Grid>
	);
};
